import { useContext, useEffect, useState, useCallback } from "react";
import { TargetsContext, TestsContext } from "../contexts";
import { testLatencyAsync } from "../utilities";
import { useCounter } from "./UseCounter";

//const defaultMaxTime = 2500; // The default time for all the tests for each target.
//const defaultMaxTests = 8; // The default number of tests to run for each target.

/**
 *  Hook to run a series of latency tests against several targets.
 *
 */

export const UseTesting = (targets, maxTestTime, maxTests, onDone) => {
  const targetDescriptions = useContext(TargetsContext);
  const { dispatch } = useContext(TestsContext);
  const [running, setRunning] = useState(false);

  // console.log(`min and max: ${targets.min} ${targets.max}`);

  const singleTest = targets.min === targets.max; // Is this used for tests against single or multiple targets.

  /** Function: Handle done counting event.
   */
  const onDoneCounting = useCallback(() => {
    if (!singleTest && onDone) {
      onDone();
    }
  }, [onDone, singleTest]);

  /** Function: Handle done testing event.
   */
  const onDoneTesting = useCallback(() => {
    if (singleTest && onDone) {
      onDone();
    }
  }, [onDone, singleTest]);

  const { startCounter, count } = useCounter(targets.min, targets.max, 3300, onDoneCounting);

  /** Function: Start the testing.
   */
  const startTesting = useCallback(() => {
    if (!singleTest) {
      startCounter();
    }
    setRunning(true);
  }, [startCounter, singleTest]);

  /** Effect: Call the latency testing.
   */
  useEffect(() => {
    const saveResults = async (results) => {
      await dispatch({ type: "append", index: count, tests: [results] });
    };

    if (running) {
      testLatencyAsync(targetDescriptions[count].url, maxTests, maxTestTime, saveResults, onDoneTesting);
    }
  }, [count, running, dispatch, maxTests, maxTestTime, onDoneTesting, targetDescriptions]);

  return {
    start: startTesting,
    count: count,
  };
};
